import { render, staticRenderFns } from "./OrderRecord.vue?vue&type=template&id=5a25c1e2&"
import script from "./OrderRecord.vue?vue&type=script&lang=js&"
export * from "./OrderRecord.vue?vue&type=script&lang=js&"
import style0 from "./OrderRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports